import React, { useState } from 'react'
import { Link } from 'react-router-dom'
// images
import SMS from '../pages/images/sms-logo.png'
import RCS from '../pages/images/rcs-logo.png'
import ProductWP from '../pages/images/productWP.png'
import VoiceCall from '../pages/images/voicecall.png'
import Voice from '../pages/images/voice.png'
import txtspeech from '../pages/images/txttospeech.png'
import ctc from '../pages/images/ctc.png'
import Email from '../pages/images/EmailCompign.png'
import tiniurl from '../pages/images/tineUrl.png'
import workflow from '../pages/images/workflow.png'
import tempcat from '../pages/images/tempCateg.png'
import apiimage from '../pages/images/apiimge.png'
import productreport from '../pages/images/productReport.png'
import auditreport from '../pages/images/auditReport.png'
import reportDownload from '../pages/images/reportDownloa.png'
import Shopify from '../pages/images/shopify-image.png'
import clavertop from '../pages/images/CleverTap.png'
import monegage from '../pages/images/moengage.png'
import webingege from '../pages/images/WebEnggage.png'
import quibe from '../pages/images/quabe.png'
import pabbly from '../pages/images/pabbly-image.png'
import lines from '../pages/images/lines-munu.png'
import google from '../pages/images/google-sheets.png'


// icons
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { FaChalkboard } from "react-icons/fa";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { FaScrewdriverWrench } from "react-icons/fa6";
import { FaLink } from "react-icons/fa";


function Producthome() {
    const services = [
        {
            title: "SMS",
            description: "Instant, reliable messaging to any phone !",
            slug: "/Comingsoon",
            image: SMS
        },
        {
            title: "RCS",
            description: "Rich, interactive messaging with media support !",
            slug: "/Comingsoon",
            image: RCS
        },
        {
            title: "WhatsApp",
            description: "Secure, trusted messaging on WhatsApp Business !",
            slug: "/WAMessage/WASendMessage/Index",
            image: ProductWP
        },
        {
            title: "Voice",
            description: "Connect customers instantly through high-quality voice !",
            slug: "/Comingsoon",
            image: VoiceCall
        },
        {
            title: "IVR",
            description: "Smart call routing with voice menus !",
            slug: "/Comingsoon",
            image: Voice
        },
        {
            title: "Text-to-Speech",
            description: "Convert text into natural-sounding voice !",
            slug: "/Comingsoon",
            image: txtspeech
        },
        {
            title: "ClickToCall",
            description: "Simplify customer outreach with click-to-call !",
            slug: "/Comingsoon",
            image: ctc
        },
        {
            title: "Email",
            description: "Email marketing strategies for better conversions !",
            slug: "/Comingsoon",
            image: Email
        }
    ];

    const utility = [
        {
            title: "URL Shortener",
            description: "Used for sharing links on social media.",
            slug: "/Comingsoon",
            image: tiniurl
        },
        {
            title: "Journeys",
            description: "Multi-campaign messaging with smart fallback handling.",
            slug: "/Comingsoon",
            image: workflow
        },
        {
            title: "Template Category",
            description: "Event planning templates for smooth execution.",
            slug: "/Comingsoon",
            image: tempcat
        },
        {
            title: "API's",
            description: "Secure API practices for developers.",
            slug: "/Comingsoon",
            image: apiimage
        },
        {
            title: "Reports",
            description: "Campaign performance analysis and key insights.",
            slug: "/Comingsoon",
            image: productreport
        },
        {
            title: "System Audit",
            description: "Check system activities and transaction details.",
            slug: "/Comingsoon",
            image: auditreport
        },
        {
            title: "Download Center",
            description: "View and download all your reports in one place.",
            slug: "/Comingsoon",
            image: reportDownload
        }
    ];

    const plugins = [
        {
            title: "Shopify",
            description: "With Shopify, users can manage everything.",
            slug: "/Comingsoon",
            image: Shopify
        },
        {
            title: "CleverTap",
            description: "CleverTap is widely used by product teams.",
            slug: "/Comingsoon",
            image: clavertop
        },
        {
            title: "MoEngage",
            description: "Mobile-first and digital-first businesses.",
            slug: "/Comingsoon",
            image: monegage
        },
        {
            title: "",
            description: "Mobile-first and digital-first businesses.",
            slug: "/Comingsoon",
            image: webingege
        },
        {
            title: "Zoho Flow",
            description: "It supports a wide range of apps.",
            slug: "/Comingsoon",
            image: quibe
        },
        {
            title: "Pabbly",
            description: "Pabbly helps businesses streamline repetitive tasks.",
            slug: "/Comingsoon",
            image: pabbly
        },
        {
            title: "Freshworks",
            description: "A customer engagement and software company.",
            slug: "/Comingsoon",
            image: lines
        },
        {
            title: "Google Sheets",
            description: "Widely used by individuals and businesses.",
            slug: "/Comingsoon",
            image: google
        }
    ];


    const [showtooltip1, setshowtooltip1] = useState(null)
    const [showtooltip2, setshowtooltip2] = useState(null)
    const [showtooltip3, setshowtooltip3] = useState(null)

    return (
        <>

            {/* channels */}
            <div className='bg-[#d3d7db] py-2 px-2 flex justify-between w-[100%] mt-2 rounded-t-[12px] pt-[70px] dark:bg-[#121519]'>
                <div className='flex items-center gap-1'>
                    <span className='text-[18px] text-[#000] font-semibold dark:text-[#fff]'>Channels </span>
                    <FaChalkboard className='text-[18px] dark:text-[#fff]' />
                </div>
                <div>
                <Link to='/DailyConsumption'>
                    <button className='bg-[#316bb0] flex text-[#fff] items-center text-[12px] font-semibold p-1 rounded-lg gap-1'><FaMoneyBillTransfer />  Daily Consumption</button>
                    </Link>
                </div>
            </div>
            <div className='w-[100%] flex flex-wrap gap-4 items-center py-8 px-6 dark:bg-[#121519] '>
                {services.map((item, index) => (
                    <div className='flex items-center gap-2 flex-col flex-nowrap w-[190px]  py-[12px] px-[10px] rounded-[10px] shadow-[inset_0_8px_12px_0_rgb(185_198_203_/_30%)] border-[#e3e9ef] border-[1px] relative dark:border-none'>
                        <div className='w-[100%] flex justify-end'>
                            <IoCheckmarkCircle
                                onMouseOver={() => {
                                    setshowtooltip1(index);
                                }}
                                onMouseLeave={() => {
                                    setshowtooltip1(false);
                                }}
                                className='text-[24px] text-[#2ecc71] cursor-pointer'
                            />
                        </div>
                        <img className='w-[36px]' src={item.image} alt="" />
                        <h1 className='text-[#000] text-[14px] font-semibold dark:text-[#fff]'>{item.title}</h1>
                        <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff]'>{item.description}</span>
                        <Link to={item.slug}>
                            <button className='w-[100%] flex justify-center items-center bg-gradient-to-r from-[#576a81] to-[#45a29e] border-0 rounded-[12px] text-white cursor-pointer  font-medium text-[12px] leading-[2.5] px-4 text-center no-underline transition-shadow duration-200 ease-in-out select-none whitespace-nowrap hover:shadow-[0_0_0.15rem_rgb(0_0_0/23%),-0.1rem_-0.1rem_0.5rem_#576a8140,0.1rem_0.1rem_0.5rem_#45a29e42]'>
                                <FaArrowUpRightFromSquare />
                                Campaign</button>
                        </Link>
                        <div
                            className={`absolute top-[-80px] left-1/2 -translate-x-1/2 w-[190px] text-white text-center p-[15px] text-[14px] rounded-[15px] z-10 shadow-[0px_10px_20px_rgba(0,123,255,0.3)] [clip-path:polygon(0_0,100%_0,100%_85%,50%_100%,0_85%)] bg-[linear-gradient(135deg,_rgb(0,123,255)_0%,_rgb(0,198,255)_100%)] transition-all duration-500 ease-in-out
  ${showtooltip1 === index ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}
  `}
                        >
                            <span>{`You have access to the ${item.title} product.`}</span>
                        </div>

                    </div>

                ))
                }

            </div>
            {/* Utilities  */}
            <div className='bg-[#d3d7db] py-2 px-2 flex justify-between w-[100%] mt-2 dark:mt-0 dark:bg-[#121519] '>
                <div className='flex items-center gap-1'>
                    <span className='text-[18px] text-[#000] font-semibold dark:text-[#fff]'>Utilities  </span>
                    <FaScrewdriverWrench className='text-[18px] dark:text-[#fff]' />
                </div>
            </div>
            <div className='w-[100%] flex flex-wrap gap-4 items-center py-8 px-6 dark:bg-[#121519] '>
                {utility.map((item, index) => (
                    <div className='flex items-center gap-2 flex-col flex-nowrap w-[190px]  py-[12px] px-[10px] rounded-[10px] shadow-[inset_0_8px_12px_0_rgb(185_198_203_/_30%)] border-[#e3e9ef] border-[1px] relative dark:border-none'>
                        <div className='w-[100%] flex justify-end'>
                            <IoCheckmarkCircle
                                onMouseOver={() => {
                                    setshowtooltip2(index);
                                }}
                                onMouseLeave={() => {
                                    setshowtooltip2(false);
                                }}
                                className='text-[24px] text-[#2ecc71] cursor-pointer'
                            />
                        </div>
                        <img className="w-[140px] h-[32px] object-contain" src={item.image} alt="" />
                        <h1 className='text-[#000] text-[14px] font-semibold dark:text-[#fff]'>{item.title}</h1>
                        <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff]'>{item.description}</span>
                        <button className='w-[100%] flex justify-center items-center bg-gradient-to-r from-[#576a81] to-[#45a29e] border-0 rounded-[12px] text-white cursor-pointer  font-medium text-[12px] leading-[2.5] px-4 text-center no-underline transition-shadow duration-200 ease-in-out select-none whitespace-nowrap hover:shadow-[0_0_0.15rem_rgb(0_0_0/23%),-0.1rem_-0.1rem_0.5rem_#576a8140,0.1rem_0.1rem_0.5rem_#45a29e42]'>
                            <FaArrowUpRightFromSquare />
                            Visit</button>

                        <div
                            className={`absolute top-[-80px] left-1/2 -translate-x-1/2 w-[190px] text-white text-center p-[15px] text-[14px] rounded-[15px] z-10 shadow-[0px_10px_20px_rgba(0,123,255,0.3)] [clip-path:polygon(0_0,100%_0,100%_85%,50%_100%,0_85%)] bg-[linear-gradient(135deg,_rgb(0,123,255)_0%,_rgb(0,198,255)_100%)] transition-all duration-500 ease-in-out
  ${showtooltip2 === index ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}
  `}
                        >
                            <span>{`You have access to the ${item.title} product.`}</span>
                        </div>

                    </div>

                ))
                }

            </div>
            {/* Plugins  */}
            <div className='bg-[#d3d7db] py-2 px-2 flex justify-between w-[100%] mt-2 dark:mt-0  dark:bg-[#121519]'>
                <div className='flex items-center gap-1'>
                    <span className='text-[18px] text-[#000] font-semibold dark:text-[#fff]'>Plugins   </span>
                    <FaLink className='text-[18px] dark:text-[#fff]' />
                </div>
            </div>
            <div className='w-[100%] flex flex-wrap gap-4 items-center py-8 px-6 dark:bg-[#121519] '>
                {plugins.map((item, index) => (
                    <div className='flex items-center gap-2 flex-col flex-nowrap w-[190px]  py-[12px] px-[10px] rounded-[10px] shadow-[inset_0_8px_12px_0_rgb(185_198_203_/_30%)] border-[#e3e9ef] border-[1px] relative dark:border-none'>
                        <div className='w-[100%] flex justify-end'>
                            <IoCheckmarkCircle
                                onMouseOver={() => {
                                    setshowtooltip3(index);
                                }}
                                onMouseLeave={() => {
                                    setshowtooltip3(false);
                                }}
                                className='text-[24px] text-[#2ecc71] cursor-pointer'
                            />
                        </div>
                        <img className="w-[140px] h-[32px] object-contain" src={item.image} alt="" />
                        <h1 className='text-[#000] text-[14px] font-semibold dark:text-[#fff]'>{item.title}</h1>
                        <span className='text-[#777777] text-[12px] font-semibold text-center dark:text-[#fff]'>{item.description}</span>
                        <button className='w-[100%] flex justify-center items-center bg-gradient-to-r from-[#576a81] to-[#45a29e] border-0 rounded-[12px] text-white cursor-pointer  font-medium text-[12px] leading-[2.5] px-4 text-center no-underline transition-shadow duration-200 ease-in-out select-none whitespace-nowrap hover:shadow-[0_0_0.15rem_rgb(0_0_0/23%),-0.1rem_-0.1rem_0.5rem_#576a8140,0.1rem_0.1rem_0.5rem_#45a29e42]'>
                            <FaArrowUpRightFromSquare />
                            Plugins</button>

                        <div
                            className={`absolute top-[-80px] left-1/2 -translate-x-1/2 w-[190px] text-white text-center p-[15px] text-[14px] rounded-[15px] z-10 shadow-[0px_10px_20px_rgba(0,123,255,0.3)] [clip-path:polygon(0_0,100%_0,100%_85%,50%_100%,0_85%)] bg-[linear-gradient(135deg,_rgb(0,123,255)_0%,_rgb(0,198,255)_100%)] transition-all duration-500 ease-in-out
  ${showtooltip3 === index ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}
  `}
                        >
                            <span>{`You have access to the ${item.title} product.`}</span>
                        </div>

                    </div>

                ))
                }

            </div>

        </>
    )
}

export default Producthome
